import React, {useCallback} from "react"
import {PaginatedSelector} from "@/components/paginated-selector/paginated-selector";
import {apiV2} from "@/api/axiosConfig";

import {UserDataTypes} from "@/types/user-data-types";
import {convertV1ToV2, PaginatedResponse} from "@/types/PaginatedResponse";

type UserSelectorProps = {
    ids: string[];
    onChange: (ids: string[]) => void;
    clientID: string;
    departmentID?: string | null;
}



export function UserSelector({ids, onChange, clientID, departmentID}: UserSelectorProps) {
    const headers = [
        "First Name",
        "Last Name",
        "Email"
    ]

    const getUsers = useCallback(async (search: string, page: number) => {
        const params: Record<string, unknown> = {
            clientID,
            search,
            page,
            limit: 10,
            archived: false,
        }
        if (departmentID) params.departmentID = departmentID

        const res = await apiV2.get<PaginatedResponse<UserDataTypes>>("users", { params })

        return convertV1ToV2(res.data, 10)
    }, [clientID])

    const getColumns = useCallback((user: UserDataTypes) => {
        return [
            user.profile.firstName,
            user.profile.lastName,
            user.email
        ]
    }, [])


    return <PaginatedSelector
        headers={headers}
        selectedIDs={ids}
        setSelectedIDs={onChange}
        getItems={getUsers}
        getColumns={getColumns}
    />
}